import { useAuth } from '@/processes'

export const Logout = ({ children }) => {
	const {handleLogout} = useAuth()

	return <span onClick={handleLogout}>{children}</span>
}
